export const PRODUCT_NAMES = {
  fisdom: "fisdom",
  finity: "finity",
};

export const PULL_REFRESH_STATE = {
	IS_SUCCESS: 'isSuccess',
	IS_FAILED: 'isFailed',
};